module.exports = __webpack_public_path__ + "img/CT.Bridges.Substructure.Bank_Seat_Abutment.Reinforced_Concrete.f9852c84.png";